@if (state() === "loading") {
  <app-loading />
}

@if (state() === "error") {
  <app-error-data
    [title]="isArabic() ? 'حدث خطأ أثناء تحميل البيانات' : 'Something went wrong'"
    [showRetry]="true"
    (retry)="pageChange.emit(currentPage())" />
}

@if (state() === "success") {
  <app-tables
    [headerItems]="tableHeaderData()"
    [rows]="rows()"
    (toggleDropdown)="toggleDropdown($event)"
    [currentActions]="currentActions()"
    (actionTrigger)="handleAction($any($event))"
    [isFiltersApplied]="isFiltersApplied()"
    [emptyFilterTitle]="isArabic() ? 'لا توجد طلبات دفع تطابق الفلترة' : 'No payment requests match your criteria.'"
    [emptyContentTitle]="isArabic() ? 'لا توجد طلبات دفع' : 'No Payment Requests Found'"
    [emptyContentDescription]="
      isArabic() ? 'لم يتم إنشاء أي طلبات دفع بعد.' : 'No payment requests have been created yet.'
    " />

  <app-pagination
    [itemsPerPage]="itemsPerPage()"
    [currentPage]="currentPage()"
    [getPageNumbers]="pageNumbers()"
    [totalPages]="totalPages()"
    [startItem]="startItem()"
    [endItem]="endItem()"
    [totalItems]="totalItems()"
    (previousPage)="onPreviousPage()"
    (nextPage)="onNextPage()"
    (goToPage)="onGoToPage($event)"
    (changePageNumber)="onChangePageNumber($event)"
    (pageSizeChange)="onPageSizeChange()" />
}
